import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = { class: "product-units" };
const _hoisted_2 = { class: "product-units__table" };
const _hoisted_3 = { class: "product-units__head" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = ["title"];
const _hoisted_7 = { class: "product-units__hide-mobile" };
const _hoisted_8 = { class: "product-units__hide-mobile" };
const _hoisted_9 = {
    key: 2,
    class: "product-units__hide-mobile"
};
const _hoisted_10 = { class: "product-units__unit-name" };
const _hoisted_11 = { class: "product-units__unit-price" };
const _hoisted_12 = {
    key: 1,
    class: "product-units__minimum-quantity-quantity-increment"
};
const _hoisted_13 = { class: "product-units__weight product-units__hide-mobile" };
const _hoisted_14 = { class: "product-units__weight product-units__hide-mobile" };
const _hoisted_15 = {
    key: 2,
    class: "product-units__contained-bundle-unit product-units__hide-mobile"
};
import { computed } from 'vue';
import Price from './Price.vue';
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductPackagingUnits',
    props: {
        variant: {},
        displayProductUnits: {},
        displayContainedUnits: { type: Boolean },
        displayMsrp: { type: Boolean },
        showPriceUnavailableAltText: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const showMinimumQuantityQuantityIncrement = hasMinimumQuantityQuantityIncrement(props.variant);
        const filteredUnits = computed(() => {
            if (props.displayProductUnits) {
                // use ordering of 'displayProductUnits'
                const units = [];
                props.displayProductUnits.forEach((unitCode) => {
                    const productUnit = props.variant.units.find((unit) => unit.unitCode === unitCode);
                    if (productUnit) {
                        units.push(productUnit);
                    }
                });
                return units;
            }
            return props.variant.units;
        });
        function hasMinimumQuantityQuantityIncrement(variant) {
            if (!variant.units) {
                return false;
            }
            // Iterate through the units and check if any have minimumQuantity or quantityIncrement
            for (let unit of variant.units) {
                if ((unit.minimumQuantity != undefined && unit.minimumQuantity > 1) || unit.quantityIncrement != undefined) {
                    return true;
                }
            }
            return false;
        }
        function isOrderingUnit(unit) {
            return !!props.variant.orderingUnits.find(ou => ou.unitCode === unit.unitCode);
        }
        return (_ctx, _cache) => {
            const _directive_b_tooltip = _resolveDirective("b-tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("table", _hoisted_2, [
                    _createElementVNode("tr", _hoisted_3, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('product.unit')), 1),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        (__props.displayMsrp)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_4, _toDisplayString(_ctx.$t('product.price_msrp')), 1))
                            : _createCommentVNode("", true),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('product.price')), 1),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        (_unref(showMinimumQuantityQuantityIncrement))
                            ? (_openBlock(), _createElementBlock("th", _hoisted_5, [
                                _withDirectives((_openBlock(), _createElementBlock("span", {
                                    class: "",
                                    title: _ctx.$t('product.minimum-quantity_quantity-increment.help')
                                }, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('product.minimum-quantity_quantity-increment')) + " ", 1),
                                    _createVNode(Icon, {
                                        name: "question-circle",
                                        "icon-style": "light"
                                    })
                                ], 8, _hoisted_6)), [
                                    [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        {
                                            hover: true,
                                            righttop: true
                                        }
                                    ]
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('product.gross_weight')), 1),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('product.net_weight')), 1),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        (__props.displayContainedUnits)
                            ? (_openBlock(), _createElementBlock("th", _hoisted_9, _toDisplayString(_ctx.$t('product.contained_bundle_unit')), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[12] || (_cache[12] = _createTextVNode()),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUnits.value, (unit, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            class: _normalizeClass(["product-units__unit", { 'product-units__unit--ordering': isOrderingUnit(unit) }])
                        }, [
                            _createElementVNode("td", _hoisted_10, [
                                (unit.bundleUnit)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('product.unit_bundled', {
                                            unit: unit.unit,
                                            quantity: unit.bundleUnit.quantity,
                                            bundle_unit: unit.bundleUnit.unit
                                        })), 1)
                                    ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode("\n                        1 " + _toDisplayString(_ctx.$unit(unit)), 1)
                                    ], 64))
                            ]),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            (__props.displayMsrp)
                                ? (_openBlock(), _createElementBlock("td", {
                                    key: 0,
                                    class: _normalizeClass(["product-units__unit-msrp", { 'product-units__unit-msrp--empty': !unit.price?.unitMsrp }])
                                }, [
                                    (unit.price && unit.price.unitMsrp)
                                        ? (_openBlock(), _createBlock(Price, {
                                            key: 0,
                                            currency: unit.price.currency,
                                            amount: unit.price.unitMsrp
                                        }, null, 8, ["currency", "amount"]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createTextVNode("–")
                                        ], 64))
                                ], 2))
                                : _createCommentVNode("", true),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("td", _hoisted_11, [
                                (unit.price)
                                    ? (_openBlock(), _createBlock(Price, {
                                        key: 0,
                                        currency: unit.price.currency,
                                        amount: unit.price.unitPrice,
                                        original: unit.price.originalUnitPrice
                                    }, null, 8, ["currency", "amount", "original"]))
                                    : (__props.showPriceUnavailableAltText)
                                        ? _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('product.price_unavailable_alt_text')), 1)
                                        ])
                                        : _createCommentVNode("", true)
                            ]),
                            _cache[8] || (_cache[8] = _createTextVNode()),
                            (_unref(showMinimumQuantityQuantityIncrement))
                                ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(unit.minimumQuantity || '-') + " / " + _toDisplayString(unit.quantityIncrement || '-'), 1))
                                : _createCommentVNode("", true),
                            _cache[9] || (_cache[9] = _createTextVNode()),
                            _createElementVNode("td", _hoisted_13, _toDisplayString(unit.grossWeightKg), 1),
                            _cache[10] || (_cache[10] = _createTextVNode()),
                            _createElementVNode("td", _hoisted_14, _toDisplayString(unit.netWeightKg), 1),
                            _cache[11] || (_cache[11] = _createTextVNode()),
                            (__props.displayContainedUnits)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(unit.bundleUnit ? (unit.bundleUnit.quantity + ' ' + unit.bundleUnit.unit) : ''), 1))
                                : _createCommentVNode("", true)
                        ], 2));
                    }), 128))
                ])
            ]));
        };
    }
});
